import { CasePreview } from '../../case/model/case.model';
import { createAction, props } from '@ngrx/store';

export const fetchBuildingCase = createAction('[Case] fetch building case', props<{ buildingId: number }>());

export const fetchBuildingCaseSuccess = createAction('[Case] fetch building case success', props<{ casePreviews: CasePreview[] }>());

export const fetchBuildingCaseFailure = createAction('[Case] fetch building case failure', props<{ error: any }>());
